import React from 'react';

import { ThemeConfig } from '../themes';
import SharedAppBar, { makeLogoStyles, makeNavStyles, makeNavDrawerStyles } from '../components/SharedAppBar';
import { makeBtStyles } from '../Theme';
import { MIN_DESKTOP_SIZE } from '../utils';


const useLogoStyles = makeLogoStyles( (theme: ThemeConfig) => ({
  // layout specific styles here
}));

const useNavStyles = makeNavStyles( (theme: ThemeConfig) => ({
  // layout specific styles here
  linkContainer: {
    display: 'inline'
  },
}));

const useNavDrawerStyles = makeNavDrawerStyles( (theme: ThemeConfig) => ({
  // layout specific styles here
}));

const useStyles = makeBtStyles( theme => ({
  desktopMenuClasses: {
    [theme.breakpoints.down(MIN_DESKTOP_SIZE - 90)]: {
      display: 'none'
    }
  },
  draweMenuClasses: {
    [theme.breakpoints.up(MIN_DESKTOP_SIZE - 90)]: {
      display: 'none'
    }
  }
}));

export default function AppBar() {
  const classes = useStyles();
  const logoClasses = useLogoStyles();
  const navClasses = useNavStyles();
  const navDrawerClasses = useNavDrawerStyles();

  return <SharedAppBar classes={classes} navClasses={navClasses} navDrawerClasses={navDrawerClasses} logoClasses={logoClasses} showSocialMedia={true} />;
}

AppBar.propTypes = {
};
